/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    graphData : null,
};


const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.graphDataAction.REQUEST_GRAPH_DATA:
      return {
        ...state,
    };
    case actions.graphDataAction.GRAPH_DATA_RECEIVED:
          return{
      ...state,
      graphQuestionId : action.data.question_ID,
      graphData : action.data.graphData,
      // userid: action.payload.user_ID,
      // projectid: action.payload.project_ID,
    };

    default:
      return state;
  }
};

export default reducer;
